(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  /* ── Sticky header ── */
  class StickyHeader extends HTMLElement {
    constructor() { super(); }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.setHeaderHeight();
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => { this.preventReveal = false; }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }
      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((d) => d.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  /* ── Mobile hamburger toggle ── */
  (function () {
    var btn = document.getElementById('synq-hamburger-btn');
    var panel = document.getElementById('synq-mobile-nav');
    if (!btn || !panel) return;

    btn.addEventListener('click', function () {
      var isOpen = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!isOpen));
      panel.setAttribute('aria-hidden', String(isOpen));
      panel.classList.toggle('synq-mobile-nav--open', !isOpen);
    });
  })();

  /* ── Smooth scroll & Anchor Mapping logic ── */
  (function () {
    // Mapping of clean URLs/hashes to exact DOM target classes or IDs
    var ANCHOR_MAP = {
      'WhySynq': 'WhySynq',
      'how-it-works': 'synq-ritual__wrap',
      'reviews': 'reviews-scroll-shell',
      'faq': 'synq-faq-section',
      'synq-ritual__wrap': 'synq-ritual__wrap',
      'reviews-scroll-shell': 'reviews-scroll-shell',
      'synq-faq-section': 'synq-faq-section'
    };

    function getTargetElement(key) {
      if (!key) return null;
      var cleanKey = key.replace(/^#\/?/, '').replace(/^\//, '');
      var identifier = ANCHOR_MAP[cleanKey] || cleanKey;
      return document.getElementById(identifier) || document.querySelector('.' + identifier);
    }

    function scrollToElement(target) {
      if (!target) return;
      var headerH = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height') || '0', 10);
      var top = target.getBoundingClientRect().top + window.pageYOffset - headerH - 16;
      window.scrollTo({ top: top, behavior: 'smooth' });
    }

    var isHome = window.location.pathname === '/' || window.location.pathname === '' || window.location.pathname === '/index';

    // 1. Handle in-page clicks on the homepage
    document.querySelectorAll('[data-synq-anchor]').forEach(function (link) {
      link.addEventListener('click', function (e) {
        var key = link.getAttribute('data-synq-anchor');
        var target = getTargetElement(key);

        if (isHome && target) {
          e.preventDefault();

          // Close mobile menu if open
          var panel = document.getElementById('synq-mobile-nav');
          var btn = document.getElementById('synq-hamburger-btn');
          if (panel && panel.classList.contains('synq-mobile-nav--open')) {
            panel.classList.remove('synq-mobile-nav--open');
            if (btn) btn.setAttribute('aria-expanded', 'false');
            panel.setAttribute('aria-hidden', 'true');
          }

          // Update URL hash cleanly
          if (history.pushState) {
            var cleanHash = key.replace(/^#\/?/, '').replace(/^\//, '');
            history.pushState(null, null, '#' + cleanHash);
          }

          scrollToElement(target);
        }
      });
    });

    // 2. Handle page load on the homepage when coming from another page with a hash (e.g. /#WhySynq)
    if (isHome && window.location.hash) {
      var hashKey = window.location.hash.substring(1);
      var initialTarget = getTargetElement(hashKey);

      if (initialTarget) {
        // Wait briefly for images and layout to render so scroll height is accurate
        setTimeout(function () {
          scrollToElement(initialTarget);
        }, 250);
      }
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
